import { render, staticRenderFns } from "./MemoransierGamesSection.vue?vue&type=template&id=c3acd54c&scoped=true&"
import script from "./MemoransierGamesSection.vue?vue&type=script&lang=js&"
export * from "./MemoransierGamesSection.vue?vue&type=script&lang=js&"
import style0 from "./MemoransierGamesSection.vue?vue&type=style&index=0&id=c3acd54c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3acd54c",
  null
  
)

export default component.exports